import { Component, Decisions } from '../structure';
import {
    createAccordionDecisions,
    createAlertDecisions,
    createAlertIconDecisions,
    createBackdropDecisions,
    createBadgeDecisions,
    createBannerDecisions,
    createBannerPrimaryTextDecisions,
    createBannerSecondaryTextDecisions,
    createBareIconButtonDecisions,
    createCalendarDecisions,
    createCalendarFooterDecisions,
    createCalendarSelectorDecisions,
    createCardContent,
    createCardDecisions,
    createDialogDecisions,
    createDrawerDecisions,
    createDrawerPillDecisions,
    createFlagDecisions,
    createIconDecisions,
    createLegendCircleDecisions,
    createMessageBubbleDecisions,
    createMessageTextareaDecisions,
    createMewsLogoDecisions,
    createNavigationListDecisions,
    createNestedCardDecisions,
    createSupplementaryIconDecisions,
    createSystemWideBannerDecisions,
    createTextareaDecisions,
    createTypographyDecisions,
} from './components';
import { SemanticDecisions } from './types';

export const createDecisions = ({
    decisions,
    overrides = {},
}: {
    decisions: SemanticDecisions;
    overrides?: Partial<Decisions>;
}) => ({
    [Component.Accordion]: createAccordionDecisions({ decisions }),
    [Component.Alert]: createAlertDecisions({ decisions }),
    [Component.AlertIcon]: createAlertIconDecisions({ decisions }),
    [Component.Backdrop]: createBackdropDecisions({ decisions }),
    [Component.Banner]: createBannerDecisions({ decisions, overrides: overrides[Component.Banner] }),
    [Component.BannerPrimaryText]: createBannerPrimaryTextDecisions({
        decisions,
        overrides: overrides[Component.BannerPrimaryText],
    }),
    [Component.BannerSecondaryText]: createBannerSecondaryTextDecisions({
        decisions,
        overrides: overrides[Component.BannerSecondaryText],
    }),
    [Component.BareIconButton]: createBareIconButtonDecisions({
        decisions,
        overrides: overrides[Component.BareIconButton],
    }),
    [Component.Calendar]: createCalendarDecisions({ decisions }),
    [Component.CalendarFooter]: createCalendarFooterDecisions({ decisions }),
    [Component.CalendarSelector]: createCalendarSelectorDecisions({ decisions }),
    [Component.Card]: createCardDecisions({ decisions, overrides: overrides[Component.Card] }),
    [Component.CardContent]: createCardContent({ decisions, overrides: overrides[Component.CardContent] }),
    [Component.Dialog]: createDialogDecisions({ decisions }),
    [Component.Drawer]: createDrawerDecisions({ decisions, overrides: overrides[Component.Drawer] }),
    [Component.DrawerPill]: createDrawerPillDecisions({ decisions, overrides: overrides[Component.DrawerPill] }),
    [Component.Flag]: createFlagDecisions({ decisions, overrides: overrides[Component.Flag] }),
    [Component.Icon]: createIconDecisions({ decisions, overrides: overrides[Component.Icon] }),
    [Component.LegendCircle]: createLegendCircleDecisions({ decisions, overrides: overrides[Component.LegendCircle] }),
    [Component.MessageBubble]: createMessageBubbleDecisions({
        decisions,
        overrides: overrides[Component.MessageBubble],
    }),
    [Component.MessageTextarea]: createMessageTextareaDecisions({
        decisions,
    }),
    [Component.MewsLogo]: createMewsLogoDecisions({ decisions, overrides: overrides[Component.MewsLogo] }),
    [Component.NestedCard]: createNestedCardDecisions({ decisions, overrides: overrides[Component.NestedCard] }),
    [Component.NavigationList]: createNavigationListDecisions({
        decisions,
        overrides: overrides[Component.NavigationList],
    }),
    [Component.Badge]: createBadgeDecisions({
        decisions,
        overrides: overrides[Component.Badge],
    }),
    [Component.SupplementaryIcon]: createSupplementaryIconDecisions({
        decisions,
        overrides: overrides[Component.SupplementaryIcon],
    }),
    [Component.SystemWideBanner]: createSystemWideBannerDecisions({
        decisions,
        overrides: overrides[Component.SystemWideBanner],
    }),
    [Component.Textarea]: createTextareaDecisions({ decisions, overrides: overrides[Component.Textarea] }),
    [Component.Typography]: createTypographyDecisions({ decisions, overrides: overrides[Component.Typography] }),
});
